import numeral from 'numeral';
import 'numeral/locales/de';

numeral.locale('de');

export default numeral;
